module.exports = __webpack_public_path__ + "static/media/WU_STEPS_review_inactive.0de1696d.svg";